<template>
  <!-- <PullRefresh :onRefresh="onRefresh" :config="refreshConfig" :pullStatus="getPullStatus"> -->
    <a-layout class="layout-wrap">
        <a-layout-sider style="background-color: var(--bg);" width="250px" v-model="select">
          <div class="menu">
            <div style="overflow: hidden;">
              <img class="logo" src="@/assets/logo.png" alt="">
              <VNavbar></VNavbar>
            </div>
            <div class="expand flex align-center justify-center" @click="expandMenu" :class="{'select': !select}">
              <img src="@/assets/icon-arrow-left.svg" alt="">
            </div>
          </div>
          <SwitchLang></SwitchLang>
        </a-layout-sider>
        <a-layout class="content">
          <a-layout-header style="background-color: var(--bg); height: 100px;">
            <VHeader></VHeader>
          </a-layout-header>
          <a-layout-content>
            <a-breadcrumb style="padding-bottom: 30px;">
              <a-breadcrumb-item>{{ $t('Common.' + $route.meta.title) }}</a-breadcrumb-item>
            </a-breadcrumb>
            <RouterView></RouterView>
          </a-layout-content>
          <VFooter></VFooter>
        </a-layout>
      </a-layout>
  <!-- </PullRefresh> -->
</template>

<script>
import VNavbar from './navbar.vue';
import VFooter from './footer.vue';
import VHeader from './header.vue';
import Assets from '@/components/assets.vue';
import SwitchLang from '@/components/switchLang.vue';
import PullRefresh from '@/components/Pull-refresh/index.vue';
import { RouterView } from 'vue-router';
export default {
  components: {
    VNavbar,
    VFooter,
    VHeader,
    Assets,
    SwitchLang,
    PullRefresh
  },
  data() {
    return {
      collapsed: false,
      hide: window.innerWidth > 576 ? true : false,
      visible: false,
      refreshConfig: {
        errorLabel: this.$t('Common.加载中'),
        startLabel: this.$t('Common.加载中'),
        readyLabel: this.$t('Common.加载中'),
        loadingLabel: this.$t('Common.加载中')
      },
      // 下拉刷新页面
      pullPage: [
        '/wallet',
        '/home'
      ],
      xsSpan: 5,
      smSpan: 4,
      xlSpan: 4,
      select: false
    }
  },
  computed: {
    getPageTitle() {
      return this.$store.state.pageTitle
    },
    getPullStatus() {
      let res = true;
      let current = this.$route.path;
      res = this.pullPage.includes(current);
      return res;
    }
  },
  methods: {
    onCollapse(collapsed, type) {
      // // console.log(collapsed, type);
    },
    onBreakpoint(broken) {
      // // console.log(broken);
    },
    onMouseEnter() {
      this.collapsed = false;
    },
    onMouseLeave() {
      this.collapsed = true;
    },
    showNavBar() {
      // console.log('visible :>> ', this.visible);
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    onLogout() {
      localStorage.removeItem('token');
      this.$router.replace('/login');
      this.$store.state.socketObj.close();
    },
    onRefresh() {
      this.$myEvent.$emit('refresh');
      return new Promise((resolve, reject)=> {
        setTimeout(()=> {
          resolve();
        }, 0.5 * 1000)
      })
    },
    handleResize() {
      if(window.innerWidth >= 576) {
        this.select = false;
      } else {
        this.select = true;
      }
    },
    expandMenu() {
      this.select = !this.select;
    }
  },
  mounted() {
    this.handleResize(); // 初始化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="scss" scoped>

::v-deep .ant-breadcrumb-link {
  color: var(--gold) !important;
}
.expand {
  width: 34px;
  height: 34px;
  border:1px solid var(--panel-border);
  border-radius: 99px;
  position: absolute;
  right: -17px;
  top: 40px;
  z-index: 999;
  transition: all 0.3s;

  &.select {
    transform: rotateZ(180deg);
  }
}

.menu {
  background-color: #0a0a0a;
  height: 100vh;
  border-right: 1px solid var(--panel-border);
  padding: 15px;
  .logo {
    height: 60px;
    margin-bottom: 50px;
  }
}


.layout-wrap {
  height: 100vh !important;
}

.content {
  background: var(--page) !important;
}

::v-deep .ant-layout-content {
  padding: 30px;
}

@media screen and (max-width: 768px) {
  .menu .logo {
    height: 50px;
  }

  ::v-deep .ant-layout-content {
    padding: 15px 15px 120px; /* 底部留出固定导航栏(footer-h5 ~80px) + 中间浮起金色 FAB 上探 ~38px + 安全余量，避免 FAB 遮挡内容 */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  ::v-deep .ant-layout-header {
    padding: 0 15px;
  }
}
</style>
